import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyVariable} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import TreeNodeDropdownFramework from '../../common/DropdownMenus/TreeNodeDropdownFramework';
import AddFrameworkDialog from './addframeworkdialog'
import AlertDialog from '../../common/AlertDialog';
import AlertWithRadioDialog from '../../common/AlertDialog/alertwithradio';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-navigations/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import { AddNewButtonLayout } from '../../common/Global/globalStyles.style';
import AttachmentList from './attachmentList';
import ClauseVersionDialog from './clauseversiondialog';

let userDetails = getLocalStorageVariables();
const AddChildDropdownObj = {
    icon:"add_circle",
    label:"Add Child"
}
const AddSiblingDropdownObj = {
    icon:"add_box",
    label:"Add Sibling"
}
const createVersionDropdownObj = {
    icon:"add_box",
    label:"Create Version"
}
const editDropdownObj = {
    icon:"edit",
    label:"Edit"
}
const delDropdownObj = {
    icon:"delete",
    label:"Delete"
}
const moveDropdownObj = {
    icon:"drag_handle",
    label:"Move"
}
const moveAsChild = {
    icon:"drag_handle",
    label:"Move as child"
}
const moveAsSiblingAbove = {
    icon:"drag_handle",
    label:"Move as sibling above"
}
const moveAsSiblingBelow = {
    icon:"drag_handle",
    label:"Move as sibling below"
}
const attachment = {
    icon:"attach_file",
    label:"Attachment"
}
const actionRootArr = [AddChildDropdownObj];
const frameworkActionArrChild = [AddChildDropdownObj,AddSiblingDropdownObj,editDropdownObj,delDropdownObj,moveDropdownObj,attachment];
const clauseActionArrChild = [AddChildDropdownObj,AddSiblingDropdownObj,createVersionDropdownObj,editDropdownObj,delDropdownObj,moveDropdownObj,attachment];
const moveArr = [moveAsChild, moveAsSiblingAbove, moveAsSiblingBelow];
const attachmentArr = [attachment];

class FrameworkDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader:false,

            frameworkIndex:{},
            detailFramworkIndex:{},
            oldDetailFrameworkIndex:{},

            showCreateDialog:false,
            isEdit:false,
            createNodeType:"",

            deleteReactivateId:"",
            showAlertWithRadioDialog:false,
            alertWithRadioDialogMessage:"",
            showRadio:true,

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            frameworkId:"",
            clauselevel:"",
            parentClauseId:"",
            selectedItem:{},
            prevFrameworkId:"",
            nextFrameworkId:"",
            isMoved:false,
            draggedNodeId:"",
            heading:"",
            attachmentFile:[],
            showAttachmentDialog: false,
            isFrameworkEdit:false
        }
        this.reloadListing = false;
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showFrameworkTreeDialog){

            this.setState({
                showLoader:false,
    
                frameworkIndex:{},
                detailFramworkIndex:{},
                oldDetailFrameworkIndex:{},
    
                showCreateDialog:false,
                isEdit:false,
                createNodeType:"",

                deleteReactivateId:"",
                showAlertWithRadioDialog:false,
                alertWithRadioDialogMessage:"",

                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
                frameworkId:"",
                clauselevel:"",
                parentClauseId:"",
                prevFrameworkId:"",
                nextFrameworkId:"",
                isMoved:false,
                attachmentFile:[],
                showAttachmentDialog: false,
                isFrameworkEdit:this.props.isFrameworkEdit
            },()=>{
                this.getIndexLevelFramework();
            })
        }
    }

    // Handles the closure of the framework tree dialog.
    handleAddEditDialogClose = (reloadFlag) =>{
        this.setState({
            showCreateDialog:false,
            isEdit:false,
            createNodeType:"",
            frameworkId:"",
            clauselevel:"",
            parentClauseId:"",
            selectedItem:"",
            versionControl:""
        },()=>{
            if(reloadFlag){
                this.reloadListing = true;
                this.getIndexLevelFramework();
            }
        })
    }

    // Handles the selection of an item from the dropdown menu.
    onDropDownItemClick = (item,frameworkObj) => {
        if(item.label === "Add Child"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"child",
                clauselevel:frameworkObj?(parseInt(frameworkObj.clauselevel)+1):1,
                parentClauseId:frameworkObj?parseInt(frameworkObj.frameworkClauseId):0,
                isEdit:false
            })
        }else if(item.label === "Add Sibling"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"sibling",
                clauselevel:parseInt(frameworkObj.clauselevel),
                parentClauseId:parseInt(frameworkObj.parentClauseId),
                childOrder:parseInt(frameworkObj.childOrder)+1,
                isEdit:false
            })
        }else if(item.label === "Delete"){
            let showRadio = false;
            //Since it has children show the radio buttons, and ask user
            //whether to delete the children or move the children to parent
            if(frameworkObj.hasChild == "Y"){
                showRadio = true;
            }
            this.setState({
                deleteReactivateId:frameworkObj.frameworkId,
                frameworkClauseId:frameworkObj.frameworkClauseId,
                alertWithRadioDialogMessage:"Are you sure you want to delete "+frameworkObj.heading+"?",
                showAlertWithRadioDialog:true,
                showRadio:showRadio,
            });
        }else if(item.label === "Edit"){
            this.setState({
                showCreateDialog:true,
                selectedItem:frameworkObj,
                isEdit:true,
                childOrder:parseInt(frameworkObj.childOrder),
                versionControl:isEmptyVariable(frameworkObj.versionControl)?"":frameworkObj.versionControl,
                clauselevel:frameworkObj.clauselevel,
                parentClauseId:frameworkObj.parentClauseId
            })
        }else if(item.label === "Create Version"){
            this.setState({
                showCreateDialog:true,
                createNodeType:"createVersion",
                selectedItem:frameworkObj,
                childOrder:parseInt(frameworkObj.childOrder),
                versionControl:isEmptyVariable(frameworkObj.versionControl)?"":frameworkObj.versionControl,
                clauselevel:frameworkObj.clauselevel,
                parentClauseId:parseInt(frameworkObj.parentClauseId)
            })
        }else if(item.label === "Move"){
            this.setState({
                isMoved:true,
                draggedNodeId:frameworkObj.frameworkClauseId,
                heading:frameworkObj.clauseName +": "+ frameworkObj.heading,
                hasChild:frameworkObj.hasChild,
                fromClauselevel:frameworkObj.clauselevel
            })
        }else if(item.label === "Move as child"){
            this.setState({
                moveAs:"child",
            },() => {
                if(this.state.fromClauselevel == (frameworkObj.clauselevel + 1)){
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:"Cannot move the node to it's own child."
                    })
                }else{
                    this.moveFramework(frameworkObj, this.state.draggedNodeId, this.state.moveAs);
                }
            })
        }else if(item.label === "Move as sibling above"){
            this.setState({
                moveAs:"sibling above",
            },() => {
                this.moveFramework(frameworkObj, this.state.draggedNodeId, this.state.moveAs);
            })
        }else if(item.label === "Move as sibling below"){
            this.setState({
                moveAs:"sibling below",
            },() => {
                this.moveFramework(frameworkObj, this.state.draggedNodeId, this.state.moveAs);
            })
        }else if(item.label === "Attachment"){
            this.setState({
                showAttachmentDialog:true,
                frameworkClauseId:frameworkObj.frameworkClauseId
            })
        }
    }

    // Handle delete framework info dialog close event
    handleAlertWithDialogDialogClose = () =>{
        this.setState({
            showAlertWithRadioDialog:false,
            alertWithRadioDialogMessage:""
        });
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    // Handles the node expanding event in the TreeViewComponent.
    handleNodeExpanding = async (args) => {
        const nodeData = args.nodeData;
        // When a node is expanded, this function checks if the node has children.
        if (nodeData.hasChildren) {
            // If it does, it calls the getChildFramework function to fetch the child framework data.
            this.getChildFramework(nodeData.id);
        }
    }

    // Handles node expanding event in the details framework tree, fetching child data if available.
    handleDetailsNodeExpanding = async (args) => {
        const nodeData = args.nodeData;
        if (nodeData.hasChildren) {
            this.getChildFramework(nodeData.id,true);
        }
    }

    // Updates tree data by recursively traversing the node list.
    updateTreeDataWithChildren = (list, frameworkClauseId, childNodes) => {
        return list.map(node => {
            if (node.frameworkClauseId == frameworkClauseId) {
                // Update the node's child nodes and set its expanded state to true.
                return { ...node, child: childNodes, expanded: true };
            }

            // If node has children, recursively update their data
            if (node.child && node.child.length > 0) {
                // Recursively call the updateTreeDataWithChildren function on the node's children
                const updatedChildren = this.updateTreeDataWithChildren(node.child, frameworkClauseId, childNodes);

                // Check if any child is expanded, then keep this node expanded
                const isAnyChildExpanded = updatedChildren.some(child => child.expanded);

                // Update the node's child nodes and set its expanded state based on its children's expanded state
                return {
                    ...node,
                    child: updatedChildren,
                    expanded: isAnyChildExpanded // Keep this node expanded if any child is expanded
                };
            }

            // Collapse other nodes.
            return { ...node, expanded: false };
        });
    };

    // Finds a node by frameworkClauseId in the tree structure.
    findNodeByFrameworkClauseId = (nodes, frameworkClauseId) => {
        for (let node of nodes) {
            // Check if the current node matches the frameworkClauseId
            if (node.frameworkClauseId == frameworkClauseId) {
                return node;
            }

            // If the node has children, recursively search the child nodes
            if (node.child && node.child.length > 0) {
                const result = this.findNodeByFrameworkClauseId(node.child, frameworkClauseId);
                if (result) {
                    return result;
                }
            }
        }

        return null; // If not found, return null
    };

    // Handles the previous and next navigation for the framework tree.
    handlePrevNext = (updatedTreeData, frameworkClauseId) => {
        // Find the node object corresponding to the frameworkClauseId.
        let frameworkObj = this.findNodeByFrameworkClauseId(updatedTreeData, frameworkClauseId);
        
        // Create an array of frameworkClauseIds for easy indexing.
        let frameWorkIdIndex = updatedTreeData.map(item => item.frameworkClauseId);
        // Find the index of the parent node in the frameWorkIdIndex array.
        let taskIdIndex = frameWorkIdIndex.indexOf(frameworkObj.parentId);
        
        // Initialize previous and next index variables.
        let prevIndex = -1;
        let nextIndex = -1;

        // If the parent node is found, calculate the previous and next indices.
        if(taskIdIndex > -1){
            // Calculate the previous index.
            prevIndex = taskIdIndex-1;
            // Calculate the next index, handling the edge case where it's the last node.
            nextIndex = taskIdIndex+1;
            if(nextIndex >= frameWorkIdIndex.length){
                nextIndex = -1;
            }
        }
        this.setState({
            oldDetailFrameworkIndex:updatedTreeData,
            prevFrameworkId:prevIndex > -1?frameWorkIdIndex[prevIndex]:"",
            nextFrameworkId:nextIndex > -1?frameWorkIdIndex[nextIndex]:"",
        })
    }

    // Handle next button
    nextFramework = () => {
        this.getChildFramework(this.state.nextFrameworkId,true);
    }

    // Handle Previous button
    prevFramework = () => {
        this.getChildFramework(this.state.prevFrameworkId,true);
    }

    // Recursively updates a tree data structure by adding a parentId to each node.
    addParentIdToTree = (nodes, rootParentId = null) => {
        return nodes.map(node => {
            const isRootLevel = node.clauselevel === 1; // Identify root level nodes
            const currentParentId = isRootLevel ? node.frameworkClauseId : rootParentId; // For root level, use its own ID as parentId
    
            // Update the current node with the correct parentId
            const updatedNode = {
                ...node,
                parentId: rootParentId ? rootParentId : node.frameworkClauseId // For root, parentId is itself, for children use passed rootParentId
            };
    
            // Recursively apply the same for children
            if (node.child && node.child.length > 0) {
                updatedNode.child = this.addParentIdToTree(node.child, currentParentId);
            }
    
            return updatedNode;
        });
    };

    // Finds a node by frameworkClauseId in a tree and returns it with its parents.
    findNodeWithParents = (nodes, frameworkClauseId) => {
        for (const item of nodes) {
            // Check if the current item has the matching frameworkClauseId
            if (item.frameworkClauseId == frameworkClauseId) {
                return [item];
            }
            // If the item has children, search within the child array
            if (item.hasChildren && item.child.length > 0) {
                const result = this.findNodeWithParents(item.child, frameworkClauseId);
                if (result) {
                    return [{
                        ...item,  // Copy the parent node properties
                        child: result,  // Include only the matched child
                    }]
                }
            }
        }
    }

    // Handles node expansion in the tree view.
    nodeExpanded = (args) =>{
        const updatedTreeData = this.state.frameworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: true };
            }
            return node;
        });
        this.setState({ frameworkIndex: updatedTreeData });
    }

    // Handles node collapse in the tree view.
    nodeCollapsed = (args) =>{
        const updatedTreeData = this.state.frameworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: false };
            }
            return node;
        });
        this.setState({ frameworkIndex: updatedTreeData });
    }

    // Handles node expansion in the tree view.
    nodeDetailExpanded = (args) =>{
        const updatedTreeData = this.state.detailFramworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: true };
            }
            return node;
        });
        this.setState({ detailFramworkIndex: updatedTreeData });
    }

    // Handles node collapse in the tree view.
    nodeDetailCollapsed = (args) =>{
        const updatedTreeData = this.state.detailFramworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: false };
            }
            return node;
        });
        this.setState({ detailFramworkIndex: updatedTreeData });
    }
    
    // Closes the framework tree dialog and reloads the listing.
    handleFrameworkTreeClose = () => {
        this.props.handleFrameworkTreeDialogClose(this.reloadListing)
    }

    // Displays the clause version dialog
    handleVersionClause = (frameworkObj) => {
        this.setState({
            showClauseVersionDialog: true,
            frameworkObj:frameworkObj
        })
    }

    // Closes the clause version dialog and resets the framework object.
    handleClauseVersionDialogClose = () => {
        this.setState({
            showClauseVersionDialog: false,
            frameworkObj:""
        })
    }

    // Closes the attachment dialog by updating the state.
    handleAttachmentDialogClose = () => {
        this.setState({
            showAttachmentDialog: false
        })
    }

    // Resets the state related to movement and dragged node.
    clearMove = () => {
        this.setState({
            isMoved:false,
            draggedNodeId:"",
            heading:""
        })
    }

    // Renders a clickable tree node for framework clauses.
    nodeTemplate = (frameworkObj) => {
        let clauseHeadingSplit = frameworkObj.text.split(":");
        let clauseName = clauseHeadingSplit[0] ? clauseHeadingSplit[0] : "";
        let heading = clauseHeadingSplit[1] ? clauseHeadingSplit[1] : "";
        let displayPlaceholder = `${clauseName}<p style="white-space:nowrap;margin-top:2px;">&nbsp;:&nbsp;</p>${heading}`;
        
        return (
            <div className="dialog-tree-structure-sync" style={{ maxWidth: '100%', marginTop: 0 }} 
            onClick={() => this.getframeworkclause(!isEmptyVariable(frameworkObj.parentId)?frameworkObj.parentId:frameworkObj.frameworkClauseId)}>
                <p className='task-dangerouslysethtml inner-html d-flex' style={{ marginBottom: 4}} dangerouslySetInnerHTML={{__html: displayPlaceholder}}></p>
            </div>
        )
    }

    // Renders a tree structure node with a dropdown for framework actions, displaying an arrow based on expansion state.
    frameworkTree = (frameworkObj) => {
        const arrowIconClass = frameworkObj.expanded ? "arrow-down" : "arrow-right";

        return <div className="dialog-tree-structure-sync mt-0">
        {
            !isEmptyVariable(frameworkObj) &&
                <div className="tree-node-sync">
                    <div className="tree-dropdown-layout-sync">
                        <span className={`expand-arrow ${arrowIconClass}`}></span>
                        <TreeNodeDropdownFramework
                            placeholder={frameworkObj.text}
                            description={frameworkObj.description ? frameworkObj.description : ""}
                            dropdownArr={this.state.isFrameworkEdit ?
                                (this.state.draggedNodeId == frameworkObj.frameworkClauseId ? [] :
                                (this.state.isMoved ? moveArr :
                                (this.props.rootNode?.versionType == 'clause' ? 
                                clauseActionArrChild : frameworkActionArrChild)))
                                : attachmentArr
                            }
                            labelParam={"label"}
                            className="framework-tree-node"
                            onDropDownItemClick={this.onDropDownItemClick}
                            handleOnClick={() => this.handleVersionClause(frameworkObj)}
                            dropdownId={frameworkObj}
                            // fontbold={frameworkObj.fontbold}
                            // paraMT={"4px"}
                            themeSettings={this.props.themeSettings}
                        />
                    </div>
                </div>
            }
        </div>
    }
    /************************API CALLS **************************/
    getIndexLevelFramework = () => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetIndexLevelFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:this.props.rootFrameworkId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.data.frameworkIndex;

                // Convert the object to an array of objects
                const frameworkIndex = temp.map(clause  => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: false,
                    child: [], // Empty for now; will be populated dynamically
                }));

                this.setState({
                    frameworkIndex:frameworkIndex,
                    detailFramworkIndex:frameworkIndex,
                    oldDetailFrameworkIndex:frameworkIndex,
                    showLoader:false
                });
            }else{
                this.setState({
                    frameworkIndex:{},
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }

    getChildFramework = (frameworkClauseId,isDetailNode) => {
        fetch(Constants.GetChildFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:frameworkClauseId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let childData = data.data;
                const childNodes = childData.map(clause => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: false,
                    child: [],
                }));
                if(isDetailNode == true){
                    // Add child node inside oldDetailFrameworkIndex array
                    const updatedTreeData = this.updateTreeDataWithChildren(this.state.oldDetailFrameworkIndex, frameworkClauseId, childNodes);
                    
                    // display only selected parent and child node based on click of the right arrow icon
                    const frameworkIndex = this.findNodeWithParents(updatedTreeData, frameworkClauseId);
                    
                    // Add parentId to each child node.
                    const treeData = this.addParentIdToTree(updatedTreeData);
                    
                    // Handle Previous/Next Id
                    this.handlePrevNext(treeData, frameworkClauseId);
                    this.setState({ detailFramworkIndex: frameworkIndex });
                }else{
                    const updatedTreeData = this.updateTreeDataWithChildren(this.state.frameworkIndex, frameworkClauseId, childNodes);
                    const treeData = this.addParentIdToTree(updatedTreeData);
                    treeData.map(item => item.child.map(childItem => delete childItem.hasChildren))
                    this.setState({ frameworkIndex: treeData });
                }
            }else{
                this.setState({
                    showLoader: false,
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo:data.responseMessage
                })
            }
        });
    }

    getframeworkclause = (frameworkClauseId) => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetFrameworkClause,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:frameworkClauseId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.data;
                const nestedChild = temp.filter(item => item.clauselevel == 1).map(parent => {
                    // Find children of this parent clause
                    const child = temp.filter(child => child.parentClauseId == parent.frameworkClauseId)
                    .map(item => ({
                        ...item,
                        id: item.frameworkClauseId,
                        text: `${item.clauseName}: ${item.heading}`,
                        description: item.description,
                        hasChildren: item.hasChild === 'Y',
                        expanded: false,
                        child: []
                    }));
                    return {
                        ...parent,
                        child
                    };
                })
                // Convert the object to an array of objects
                nestedChild.map(clause  => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName} : ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: true,
                    child: clause.child,
                }));
                // Add child node inside oldDetailFrameworkIndex array
                const updatedTreeData = this.updateTreeDataWithChildren(this.state.oldDetailFrameworkIndex, frameworkClauseId, nestedChild[0].child);
                // display only selected parent and child node based on click of the right arrow icon
                const frameworkIndex = this.findNodeWithParents(updatedTreeData, frameworkClauseId);

                // Add parentId to each child node.
                const treeData = this.addParentIdToTree(updatedTreeData);
                
                // Handle Previous/Next Id
                this.handlePrevNext(treeData, frameworkClauseId);

                this.setState({
                    detailFramworkIndex:frameworkIndex,
                    showLoader:false
                });
            }else{
                this.setState({
                    frameworkIndex:{},
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }

    deleteActivateFrameworkNode = (deleteChild) => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.DeleteFrameworkClause,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:this.state.frameworkClauseId,
                deleteChild:deleteChild,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    deleteReactivateId:"",
                    frameworkClauseId:"",
                    alertWithRadioDialogMessage:"",
                    showAlertWithRadioDialog:false,
                },() => {
                    this.getIndexLevelFramework();
                    this.reloadListing = true;
                });
            }else{
                this.setState({
                    showLoader:false,
                    deleteReactivateId:"",
                    frameworkClauseId:"",
                    alertWithRadioDialogMessage:"",
                    showAlertWithRadioDialog:false,

                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    moveFramework = (frameworkObj,draggedNodeId,moveAs) => {
        fetch(Constants.MoveFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:frameworkObj.frameworkId,
                fromFrameworkClauseId:draggedNodeId,
                toFrameworkClauseId:frameworkObj.frameworkClauseId,
                moveAs:moveAs,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    isMoved:false,
                    draggedNodeId:"",
                    heading:"",
                    fromClauselevel:""
                })
                this.getIndexLevelFramework();
                this.reloadListing = true;
            }else{
                this.setState({
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    /************************API CALLS END HERE**************************/

    render() {
        return(
            <div>
                <Modal className="show-framework-tree-dialog custom-dialog"
                show={this.props.showFrameworkTreeDialog} onHide={this.handleFrameworkTreeClose} backdrop="static">
                    <Modal.Header>
                        <TreeNodeDropdownFramework
                            placeholder={this.props.rootNode?.frameworkName}
                            dropdownArr={this.state.isFrameworkEdit?actionRootArr:[]}
                            labelParam={"label"}
                            onDropDownItemClick={this.onDropDownItemClick}
                            className="framework-tree"
                            fontbold={true}
                            paraMT={"1.5px"}
                            themeSettings={this.props.themeSettings}
                            rootNode={true}
                        />
                        <button 
                            onClick={this.handleFrameworkTreeClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        { 
                            this.state.showLoader && 
                            <div class="loader"></div>
                        }
                        {this.state.isMoved &&
                            <div className="row custom-row">
                                <div className="col-md-12 custom-col d-flex">
                                    <p>{`Moving this ${this.state.heading}`}</p>
                                    <span className="material-icons ml-2 c-pointer" onClick={() => this.clearMove()}>clear</span>
                                </div>
                            </div>
                        }
                        
                        <div className="row custom-row framework-tree-view">
                            <div className="col-md-3 custom-col theme-border-right" style={{minHeight:"450px"}}>
                                <p>Index</p>
                                <TreeViewComponent 
                                    fields={{
                                        dataSource: this.state.frameworkIndex,
                                        id: 'id',
                                        text: 'text',
                                        hasChildren: 'hasChildren',
                                        expanded: 'expanded',
                                        child: 'child',
                                    }}
                                    nodeTemplate={this.nodeTemplate}
                                    nodeExpanded={this.nodeExpanded}
                                    nodeCollapsed={this.nodeCollapsed}
                                    nodeExpanding={this.handleNodeExpanding}
                                />
                            </div>
                            <div className="col-md-9 custom-col">
                                <div className="d-flex justify-content-end">
                                    {
                                        !isEmptyVariable(this.state.prevFrameworkId) &&
                                        <AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginLeft:10}}>
                                            <a onClick={this.prevFramework} href="javascript:void(0);">
                                                <span className="material-icons">arrow_back_ios</span>
                                                <p>Prev</p>
                                            </a>
                                        </AddNewButtonLayout>
                                    }
                                    {
                                        !isEmptyVariable(this.state.nextFrameworkId) &&
                                        <AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginLeft:10}}>
                                            <a onClick={this.nextFramework} href="javascript:void(0);">
                                                <p style={{marginRight:6,marginLeft:0}}>Next</p>
                                                <span className="material-icons">arrow_forward_ios</span>
                                            </a>
                                        </AddNewButtonLayout>
                                    }
                                </div>
                                <TreeViewComponent 
                                    key={this.state.isMoved} 
                                    fields={{
                                        dataSource: this.state.detailFramworkIndex,
                                        id: 'id',
                                        text: 'text',
                                        description: 'description',
                                        hasChildren: 'hasChildren',
                                        expanded: 'expanded',
                                        child: 'child',
                                    }}
                                    cssClass={'custom-framework-tree-node'}
                                    nodeTemplate={this.frameworkTree}
                                    nodeExpanded = {this.nodeDetailExpanded}
                                    nodeCollapsed = {this.nodeDetailCollapsed}
                                    nodeExpanding={this.handleDetailsNodeExpanding}
                                />
                            </div>
                        </div>
                        
                    </div>
                </Modal>

                <AddFrameworkDialog
                    isEdit={this.state.isEdit}
                    showCreateDialog={this.state.showCreateDialog}
                    handleAddEditDialogClose={this.handleAddEditDialogClose}
                    createNodeType={this.state.createNodeType}
                    clauseLevel={this.state.clauselevel}
                    parentClauseId={this.state.parentClauseId}
                    frameworkId={this.props.rootFrameworkId}
                    selectedItem={this.state.selectedItem}
                    childOrder={this.state.childOrder}
                    versionControl={this.state.versionControl}
                    themeSettings={this.props.themeSettings}
                    versionType={this.props.rootNode?.versionType}
                />

                <ClauseVersionDialog
                    showClauseVersionDialog={this.state.showClauseVersionDialog}
                    handleClauseVersionDialogClose={this.handleClauseVersionDialogClose}
                    frameworkObj={this.state.frameworkObj}
                    rootFrameworkId={this.props.rootFrameworkId}
                    isFrameworkEdit={this.state.isFrameworkEdit}
                    themeSettings={this.props.themeSettings}
                    versionType={this.props.rootNode?.versionType}
                />

                <AttachmentList
                    showAttachmentDialog={this.state.showAttachmentDialog}
                    frameworkClauseId={this.state.frameworkClauseId}
                    handleAttachmentDialogClose={this.handleAttachmentDialogClose}
                    isFrameworkEdit={this.state.isFrameworkEdit}
                    rootFrameworkId={this.props.rootFrameworkId}
                    themeSettings={this.props.themeSettings}
                />

                <AlertWithRadioDialog
                    showAlertDialog={this.state.showAlertWithRadioDialog}
                    handleAlertDialogClose={this.handleAlertWithDialogDialogClose}
                    alertDialogHeading={"Delete"}
                    alertDialogMessage={this.state.alertWithRadioDialogMessage}
                    proceedBtnClick={this.deleteActivateFrameworkNode}
                    proceedBtnLabel={"Delete"}
                    showRadio={this.state.showRadio}
                />

                <AlertDialog 
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL }
                    themeSettings={this.props.themeSettings}
                />
            </div>
        );
    }
}

export default FrameworkDialog;